import { createQueryKeys } from "@lukemorales/query-key-factory";

import { createServiceResponseSchema, postPurchaseApi } from "@/api/axios";
import {
  postPurchaseRecommendationsDataModelSchema,
  postPurchaseSurveyParamsDataModelSchema,
} from "@/domains/surveys/models/schemas";
import { getPostPurchaseUrlSignature } from "@/utils/validation";

export const postPurchaseQueryOptions = createQueryKeys("post-purchase", {
  flowParams: (orderId: number) => {
    return {
      queryKey: [orderId],
      queryFn: () => {
        return getPostPurchaseSurveyParams(orderId);
      },
    };
  },
  recommendations: (flowUuid: string) => {
    return {
      queryKey: [flowUuid],
      queryFn: () => {
        return getPostPurchaseRecommendations(flowUuid);
      },
    };
  },
});

const getPostPurchaseSurveyParams = async (orderId: number) => {
  const url = `/post-purchase/params?order_id=${orderId}`;
  const signature = getPostPurchaseUrlSignature(url);
  const response = await postPurchaseApi.get(url, {
    headers: { "X-Signature": signature },
  });

  return createServiceResponseSchema(postPurchaseSurveyParamsDataModelSchema).parse(response.data)
    .data;
};

const getPostPurchaseRecommendations = async (flowUuid: string) => {
  const url = `/post-purchase/recommendations/${flowUuid}`;
  const signature = getPostPurchaseUrlSignature(url);
  const response = await postPurchaseApi.get(url, {
    headers: { "X-Signature": signature },
  });

  return createServiceResponseSchema(postPurchaseRecommendationsDataModelSchema).parse(
    response.data,
  ).data;
};
